import { render } from "./roomService.vue?vue&type=template&id=412fc848"
import script from "./roomService.vue?vue&type=script&lang=js"
export * from "./roomService.vue?vue&type=script&lang=js"

import "./roomService.vue?vue&type=style&index=0&id=412fc848&lang=scss"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__